module.exports = __webpack_public_path__ + "static/media/indeterminate.0808fa0f.svg";